import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import {
  borderMixin,
  type ColumnTable,
  columnTableMixin
} from './column-table-mixin';

export const ColumnComparisonTableMobile = styled.div.attrs<ColumnTable>({
  className: createReadableClass({
    component: 'column-comparison-table-mobile',
    element: 'container'
  })
})`
  ${borderMixin}
  ${columnTableMixin}
`;
